import MediaKitComponent from './MediaKitComponent';

const MediaKit = ({ slice }) => <MediaKitComponent slice={slice} />;

export default MediaKit;
